<template>
  <NavigationHeader :title="wp.title" />
</template>

<script>
export default {
  name: 'WritingHeader',
  inject: ['wp']
}
</script>
